import { useState, useRef, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

interface PdfViewerProps {
  fileUrl: string;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl }) => {
  const [numPages, setNumPages] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [pageWidth, setPageWidth] = useState<number | undefined>(undefined);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024; // lg breakpoint
      if (isMobile && containerRef.current) {
        // Mobile: Fit to width (subtract padding)
        setPageWidth(containerRef.current.offsetWidth - 32);
      } else {
        // Desktop: Use fixed scale
        setPageWidth(undefined);
      }
    };

    // Initial check
    setTimeout(() => {
      handleResize();
    }, 100);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="flex flex-col gap-4 w-full md:w-auto">
      <div
        ref={containerRef}
        className="rounded-lg overflow-auto max-h-[80vh] bg-gray-100 p-4 card"
      >
        {loading && (
          <p className="text-center text-gray-500 py-6">Loading PDF...</p>
        )}

        <Document
          file={fileUrl}
          onLoadSuccess={({ numPages }) => {
            if (numPages > 0) {
              setNumPages(numPages);
              setLoading(false);
            }
          }}
          onLoadError={(error) => console.error('PDF load error:', error)}
          className="w-full flex flex-col items-center"
        >
          {Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              scale={pageWidth ? undefined : 1.3}
              width={pageWidth}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className="mb-4 shadow-sm"
            />
          ))}
        </Document>
      </div>
    </div>
  );
};
